import React from 'react';
import { TableInstance } from 'react-table';

import { Tenant } from '@work4all/models/lib/Classes/Tenant.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { IEntityTable } from '../entity-table/EntityTable';
import { EntityTableV8 } from '../entity-table/EntityTableV8';
import { useEntityDataTableV8 } from '../entity-table/use-entity-data-table-v8';
import schema from '../schemata/tenant-table-schema.json';

const defaultSort = [{ field: 'id', direction: SortDirection.DESCENDING }];

export const TenantTable = React.forwardRef<TableInstance, IEntityTable>(
  function TenantTable(_props) {
    const { entity: entityType } = schema as never;
    const tableProps = {
      schema: schema as never,
      defaultSort,
    };
    const dataTable = useEntityDataTableV8<Tenant, never>({
      ...tableProps,
    });

    return (
      <EntityTableV8
        entityType={entityType}
        {...dataTable}
        {..._props}
        actions={{
          add: undefined,
          remove: undefined,
          groupingEnabled: false,
          createWidget: false,
        }}
        overrides={{
          areas: {
            left: null,
            right: null,
          },
        }}
      />
    );
  }
);
